module.exports = __webpack_public_path__ + "img/Widget_card_headpics_EB_space.4c86c1d1.jpg";